import { Box, Typography, styled } from "@mui/material";

export const ErrorContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "12px",
  padding: "16px",
  backgroundColor: theme.palette.status?.error || "#EF5350",
  borderRadius: "12px",
  width: "100%",
}));

export const ErrorList = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
  flex: 1,
});

export const ErrorItem = styled(Typography)({
  color: "white",
  fontSize: "16px",
  fontFamily: "Nunito, sans-serif",
  fontWeight: 700,
  lineHeight: "140%",
  margin: 0,
  "&:before": {
    content: '"•"',
    marginRight: "8px",
  },
});
